/* RCC Holiday Cottage theme behaviour. No dependencies.
   Cart: Shopify AJAX Cart API (/cart.js, /cart/add.js, /cart/change.js).
   Search: Shopify predictive search (/search/suggest.json). */
(() => {
	const $ = (s, r = document) => r.querySelector(s);
	const $$ = (s, r = document) => [...r.querySelectorAll(s)];
	const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
	const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
	const fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency });
	const money = (cents) => fmt.format(cents / 100).replace(/\.00$/, '');
	const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
	const icon = (name) =>
		({
			plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
			minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>'
		})[name];

	/* ---------- panels: menu, cart, search ---------- */
	const open = new Set();
	function lock() {
		document.documentElement.classList.toggle('rcc-lock', open.size > 0);
	}
	function show(name) {
		const panel = $(`[data-rcc-panel="${name}"]`);
		if (!panel) return false;
		panel.hidden = false;
		requestAnimationFrame(() => panel.classList.add('is-on'));
		panel.removeAttribute('inert');
		panel.setAttribute('aria-hidden', 'false');
		$(`[data-rcc-scrim="${name}"]`)?.classList.add('is-on');
		open.add(name);
		lock();
		if (name === 'search') setTimeout(() => $('[data-rcc-search-input]')?.focus(), 60);
		return true;
	}
	function hide(name) {
		const panel = $(`[data-rcc-panel="${name}"]`);
		if (!panel) return;
		panel.classList.remove('is-on');
		panel.setAttribute('inert', '');
		panel.setAttribute('aria-hidden', 'true');
		if (name === 'search') panel.hidden = true;
		$(`[data-rcc-scrim="${name}"]`)?.classList.remove('is-on');
		open.delete(name);
		lock();
	}
	document.addEventListener('click', (e) => {
		const opener = e.target.closest('[data-rcc-open]');
		if (opener) {
			const name = opener.dataset.rccOpen;
			if (name === 'cart' && !$('[data-rcc-panel="cart"]')) return; // no drawer: follow the link to /cart
			e.preventDefault();
			if (name === 'cart') refresh();
			show(name);
			return;
		}
		if (e.target.closest('[data-rcc-close]')) {
			const panel = e.target.closest('[data-rcc-panel]');
			if (panel) hide(panel.dataset.rccPanel);
			return;
		}
		const scrim = e.target.closest('[data-rcc-scrim]');
		if (scrim) return hide(scrim.dataset.rccScrim);
		// A menu link to a section on this page ("/#rachel" from the home page)
		// only scrolls, so close the menu too. Hide runs before the browser's jump.
		const link = e.target.closest('[data-rcc-panel="menu"] a[href*="#"]');
		if (link && link.pathname === location.pathname) hide('menu');
	});
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') [...open].forEach(hide);
	});

	/* ---------- cart ---------- */
	let cartState = null;
	async function api(path, body) {
		const res = await fetch(root + path, {
			method: body ? 'POST' : 'GET',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: body ? JSON.stringify(body) : undefined
		});
		const json = await res.json().catch(() => ({}));
		if (!res.ok) throw new Error(json.description || json.message || 'Cart error');
		return json;
	}
	function renderCart(cart) {
		cartState = cart;
		const drawer = $('[data-rcc-panel="cart"]');
		$$('[data-rcc-count]').forEach((el) => {
			el.textContent = cart.item_count;
			el.hidden = cart.item_count === 0;
		});
		if (!drawer) return;
		$('[data-rcc-count-label]', drawer).textContent = `(${cart.item_count})`;
		// 0 = no free shipping offer running (snippets/rcc-free-ship.liquid).
		const free = Number(drawer.dataset.free) || 0;
		if (free) {
			// The offer is "over" the threshold, so exactly $100 still pays shipping.
			const left = Math.max(0, free - cart.total_price);
			const ship = $('[data-rcc-ship]', drawer);
			if (cart.item_count === 0) ship.textContent = `Free shipping on orders over ${money(free)}`;
			else if (cart.total_price <= free) ship.innerHTML = `You're <strong>${money(left || 1)}</strong> away from free shipping`;
			else ship.textContent = 'Your order ships free';
			$('[data-rcc-meter]', drawer).style.width = `${Math.min(100, (cart.total_price / free) * 100)}%`;
		}
		$('[data-rcc-subtotal]', drawer).textContent = money(cart.total_price);
		$('[data-rcc-empty]', drawer).hidden = cart.item_count > 0;
		$('[data-rcc-foot]', drawer).hidden = cart.item_count === 0;
		$('[data-rcc-lines]', drawer).innerHTML = cart.items
			.map((it) => {
				const img = it.image ? `${it.image}${it.image.includes('?') ? '&' : '?'}width=200` : '';
				const opt = it.variant_title && it.variant_title !== 'Default Title' ? `<span class="rcc-line__spec">${esc(it.variant_title)}</span>` : '';
				return `<div class="rcc-line">
	<a class="rcc-line__thumb" href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="" width="84" height="105" loading="lazy">` : ''}</a>
	<div class="rcc-line__info">
		<a class="rcc-line__name" href="${esc(it.url)}">${esc(it.product_title)}</a>${opt}
		<div class="rcc-qty">
			<button type="button" aria-label="One less" data-rcc-qty="${esc(it.key)}" data-to="${it.quantity - 1}">${icon('minus')}</button>
			<span>${it.quantity}</span>
			<button type="button" aria-label="One more" data-rcc-qty="${esc(it.key)}" data-to="${it.quantity + 1}">${icon('plus')}</button>
		</div>
	</div>
	<div class="rcc-line__price">${money(it.final_line_price)}<button type="button" class="rcc-line__rm" data-rcc-qty="${esc(it.key)}" data-to="0">Remove</button></div>
</div>`;
			})
			.join('');
		// Finishing touches: hide anything already in the bag; hide the row if nothing is left.
		const inBag = new Set(cart.items.map((i) => i.handle));
		let shown = 0;
		$$('[data-rcc-extra]', drawer).forEach((el) => {
			el.hidden = inBag.has(el.dataset.rccExtra) || shown >= 6;
			if (!el.hidden) shown++;
		});
		const extras = $('[data-rcc-extras]', drawer);
		if (extras) extras.hidden = shown === 0;
	}
	async function refresh() {
		try {
			renderCart(await api('cart.js'));
		} catch {
			/* leave the last state on screen */
		}
	}
	function bump() {
		$$('.rcc-bag').forEach((b) => {
			b.classList.remove('is-bump');
			void b.offsetWidth;
			b.classList.add('is-bump');
		});
	}
	async function add(items, button) {
		const label = button?.innerHTML;
		if (button) {
			button.disabled = true;
		}
		try {
			await api('cart/add.js', { items });
			await refresh();
			bump();
			if (button) button.innerHTML = button.dataset.added || 'Added';
			if (!show('cart')) location.href = root + 'cart';
		} catch (err) {
			if (button) button.innerHTML = err.message.slice(0, 40);
		} finally {
			if (button) {
				setTimeout(() => {
					button.innerHTML = label;
					button.disabled = false;
				}, 1600);
			}
		}
	}
	document.addEventListener('click', (e) => {
		const qty = e.target.closest('[data-rcc-qty]');
		if (qty) {
			const lines = qty.closest('[data-rcc-lines]');
			lines?.classList.add('is-busy');
			api('cart/change.js', { id: qty.dataset.rccQty, quantity: Number(qty.dataset.to) })
				.then(renderCart)
				.catch(refresh)
				.finally(() => lines?.classList.remove('is-busy'));
			return;
		}
		const btn = e.target.closest('[data-rcc-add]');
		if (btn) {
			e.preventDefault();
			const ids = btn.dataset.rccAdd.split(',').filter(Boolean);
			add(ids.map((id) => ({ id: Number(id), quantity: Number(btn.dataset.qty || 1) })), btn);
		}
	});
	// Product forms built by this theme: <form data-rcc-form> with name="id" and name="quantity".
	document.addEventListener('submit', (e) => {
		const form = e.target.closest('form[data-rcc-form]');
		if (!form) return;
		e.preventDefault();
		const data = new FormData(form);
		add([{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }], form.querySelector('[type="submit"]'));
	});

	/* ---------- header ---------- */
	function initHeader() {
		const header = $('[data-rcc-header]');
		if (!header) return;
		const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 24);
		onScroll();
		addEventListener('scroll', onScroll, { passive: true });
		let timer;
		const close = () =>
			$$('[data-rcc-mega-panel]', header).forEach((p) => {
				p.hidden = true;
				$(`[data-rcc-mega="${p.dataset.rccMegaPanel}"]`, header)?.setAttribute('aria-expanded', 'false');
			});
		$$('[data-rcc-mega]', header).forEach((a) => {
			const id = a.dataset.rccMega;
			const panel = $(`[data-rcc-mega-panel="${id}"]`, header);
			const enter = () => {
				clearTimeout(timer);
				close();
				panel.hidden = false;
				a.setAttribute('aria-expanded', 'true');
			};
			const leave = () => (timer = setTimeout(close, 160));
			a.parentElement.addEventListener('mouseenter', enter);
			a.parentElement.addEventListener('mouseleave', leave);
			panel.addEventListener('mouseenter', () => clearTimeout(timer));
			panel.addEventListener('mouseleave', leave);
			a.addEventListener('focus', enter);
		});
		document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
	}

	/* ---------- announcement ---------- */
	function initAnnounce() {
		$$('[data-rcc-announce]').forEach((bar) => {
			if (bar.dataset.ready) return;
			bar.dataset.ready = '1';
			const items = $$('.rcc-announce__item', bar);
			if (items.length < 2) return;
			let i = 0;
			setInterval(() => {
				items[i].classList.remove('is-on');
				i = (i + 1) % items.length;
				items[i].classList.add('is-on');
			}, Number(bar.dataset.speed) || 4200);
		});
	}

	/* ---------- search ---------- */
	function initSearch() {
		const panel = $('[data-rcc-panel="search"]');
		if (!panel || panel.dataset.ready) return;
		panel.dataset.ready = '1';
		const input = $('[data-rcc-search-input]', panel);
		const out = $('[data-rcc-search-out]', panel);
		const idle = $('[data-rcc-search-idle]', panel);
		let timer;
		let seq = 0;
		async function run(q) {
			const mine = ++seq;
			idle.hidden = !!q;
			if (!q) {
				out.innerHTML = '';
				return;
			}
			const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
			try {
				const res = await fetch(url);
				const json = await res.json();
				if (mine !== seq) return;
				const products = json.resources?.results?.products ?? [];
				if (!products.length) {
					out.innerHTML = `<p class="rcc-search__none">Nothing matches “${esc(q)}” yet. Try a colour, like red.</p>`;
					return;
				}
				out.innerHTML =
					`<p class="rcc-eyebrow">${products.length} ${products.length === 1 ? 'result' : 'results'}</p><div class="rcc-search__grid">` +
					products
						.map((p) => {
							const img = p.featured_image?.url || p.image;
							const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=200` : '';
							const price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
							return `<a class="rcc-hit" href="${esc(p.url)}">${src ? `<img src="${esc(src)}" alt="" width="72" height="90" loading="lazy">` : '<span></span>'}<span class="rcc-hit__t">${esc(p.title)}</span><span class="rcc-hit__p">${price}</span></a>`;
						})
						.join('') +
					`</div><a class="rcc-btn rcc-btn--line rcc-search__all" href="${root}search?type=product&q=${encodeURIComponent(q)}">See all results</a>`;
			} catch {
				out.innerHTML = '';
			}
		}
		input.addEventListener('input', () => {
			clearTimeout(timer);
			timer = setTimeout(() => run(input.value.trim()), 180);
		});
		panel.addEventListener('click', (e) => {
			const chip = e.target.closest('[data-rcc-suggest]');
			if (!chip) return;
			input.value = chip.dataset.rccSuggest;
			run(input.value);
			input.focus();
		});
	}

	/* ---------- reveal on scroll ---------- */
	function initReveal(scope = document) {
		if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
		if (window.Shopify && Shopify.designMode) return; // keep everything visible while editing
		const io = new IntersectionObserver(
			(entries) => {
				for (const e of entries)
					if (e.isIntersecting) {
						e.target.classList.add('rcc-rv-in');
						io.unobserve(e.target);
					}
			},
			{ rootMargin: '0px 0px -8% 0px' }
		);
		$$('[data-rcc-reveal]', scope).forEach((el) => {
			if (el.dataset.rvReady) return;
			el.dataset.rvReady = '1';
			if (el.getBoundingClientRect().top < innerHeight * 0.9) return;
			el.classList.add('rcc-rv');
			el.style.transitionDelay = `${Number(el.dataset.rccReveal) || 0}ms`;
			io.observe(el);
		});
	}

	/* ---------- hero slider ---------- */
	function makeSnow(box) {
		if (box.dataset.ready) return;
		box.dataset.ready = '1';
		const r = (a, b) => a + Math.random() * (b - a);
		let html = '';
		for (let i = 0; i < 48; i++) {
			const size = r(1.5, 5.5);
			const blur = size < 2.5 ? 0 : r(0.3, 1.2);
			html += `<i style="left:${r(0, 100)}%;animation-duration:${r(16, 26) - size * 1.4}s;animation-delay:${-r(0, 26)}s;--drift:${r(-60, 60)}px"><b style="width:${size}px;height:${size}px;opacity:${r(0.35, 0.9)};${blur ? `filter:blur(${blur}px);` : ''}animation-duration:${r(3, 7)}s;animation-delay:${-r(0, 7)}s;--sway:${r(8, 26)}px"></b></i>`;
		}
		box.innerHTML = html;
	}
	function initHero(scope = document) {
		$$('[data-rcc-hero]', scope).forEach((hero) => {
			if (hero.rcc) hero.rcc.destroy();
			const slides = $$('.rcc-hero__slide', hero);
			const dots = $$('.rcc-hero__dot', hero);
			const num = $('[data-num]', hero);
			const dur = Number(hero.dataset.duration) || 6500;
			hero.style.setProperty('--dur', `${dur}ms`);
			$$('.rcc-hero__snow', hero).forEach(makeSnow);
			let index = 0;
			let timer;
			const pad = (n) => String(n).padStart(2, '0');
			function go(i, manual) {
				index = (i + slides.length) % slides.length;
				slides.forEach((s, k) => {
					s.classList.toggle('is-on', k === index);
					s.setAttribute('aria-hidden', k === index ? 'false' : 'true');
					$$('a', s).forEach((a) => (a.tabIndex = k === index ? 0 : -1));
				});
				dots.forEach((d, k) => {
					d.classList.remove('is-on');
					if (k === index) {
						void d.offsetWidth; // restart the progress fill
						d.classList.add('is-on');
					}
				});
				if (num) num.textContent = `${pad(index + 1)} / ${pad(slides.length)}`;
				schedule();
			}
			function schedule() {
				clearTimeout(timer);
				if (slides.length > 1 && !document.hidden && !hero.dataset.hold) timer = setTimeout(() => go(index + 1), dur);
			}
			const onVis = () => {
				hero.classList.toggle('is-paused', document.hidden);
				schedule();
			};
			const onClick = (e) => {
				const d = e.target.closest('[data-go]');
				if (d) return go(Number(d.dataset.go), true);
				const s = e.target.closest('[data-step]');
				if (s) go(index + Number(s.dataset.step), true);
			};
			let sx = 0;
			let sy = 0;
			const down = (e) => {
				sx = e.clientX;
				sy = e.clientY;
			};
			const up = (e) => {
				const dx = e.clientX - sx;
				if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(e.clientY - sy)) go(index + (dx < 0 ? 1 : -1), true);
			};
			hero.addEventListener('click', onClick);
			hero.addEventListener('pointerdown', down);
			hero.addEventListener('pointerup', up);
			document.addEventListener('visibilitychange', onVis);
			hero.rcc = {
				go,
				hold(on) {
					if (on) hero.dataset.hold = '1';
					else delete hero.dataset.hold;
					schedule();
				},
				destroy() {
					clearTimeout(timer);
					hero.removeEventListener('click', onClick);
					hero.removeEventListener('pointerdown', down);
					hero.removeEventListener('pointerup', up);
					document.removeEventListener('visibilitychange', onVis);
				}
			};
			go(0);
		});
	}
	// Theme editor: selecting a slide block shows that slide and holds it.
	document.addEventListener('shopify:block:select', (e) => {
		const hero = e.target.closest('[data-rcc-hero]');
		if (!hero?.rcc) return;
		hero.rcc.go($$('.rcc-hero__slide', hero).indexOf(e.target));
		hero.rcc.hold(true);
	});
	document.addEventListener('shopify:block:deselect', (e) => e.target.closest('[data-rcc-hero]')?.rcc?.hold(false));

	/* ---------- countdown ---------- */
	function initCountdown(scope = document) {
		$$('[data-rcc-countdown]', scope).forEach((el) => {
			clearInterval(el.rccTimer);
			const month = (Number(el.dataset.month) || 12) - 1;
			const day = Number(el.dataset.day) || 25;
			const pad = (n) => String(n).padStart(2, '0');
			const tick = () => {
				// The next occurrence of the date, in the visitor's own time zone;
				// it rolls to next year the day after.
				const now = new Date();
				let t = new Date(now.getFullYear(), month, day);
				if (now >= new Date(now.getFullYear(), month, day + 1)) t = new Date(now.getFullYear() + 1, month, day);
				const ms = Math.max(0, t - now);
				const set = (k, v) => {
					const n = $(`[data-${k}]`, el);
					if (n) n.textContent = v;
				};
				set('d', String(Math.floor(ms / 864e5)));
				set('h', pad(Math.floor(ms / 36e5) % 24));
				set('m', pad(Math.floor(ms / 6e4) % 60));
				set('s', pad(Math.floor(ms / 1e3) % 60));
			};
			tick();
			el.rccTimer = setInterval(tick, 1000);
		});
	}

	/* ---------- collection filters ---------- */
	const COLOR_HEX = { Red: '#A3242C', Burgundy: '#6B1E2A', Green: '#2F5A3B', Blue: '#2B4A7A', Ivory: '#F1E9DA', Gold: '#C2A061', Orange: '#C8642A', Black: '#1C1A1E', Tan: '#B89A74' };
	const WIDTH_ORDER = ['7/8"', '1"', '1.5"', '2.5"', '4"'];
	function initCollection(scope = document) {
		const box = $('[data-rcc-collection]', scope);
		const grid = box && $('[data-rcc-grid]', box);
		if (!grid || grid.dataset.ready) return;
		grid.dataset.ready = '1';
		const cells = $$('.rcc-coll__cell', grid).map((el) => ({
			el,
			type: el.dataset.type,
			width: el.dataset.width,
			colors: el.dataset.colors.split(',').filter(Boolean),
			brand: el.dataset.brand,
			price: Number(el.dataset.price),
			created: Number(el.dataset.created),
			soon: el.dataset.soon === 'true',
			index: Number(el.dataset.index)
		}));
		const state = { type: 'all', sort: 'featured', width: new Set(), colors: new Set(), brand: new Set() };
		const sheet = $('[data-rcc-panel="filters"]', box);

		// Build each option group from what is actually in this collection.
		const values = {
			width: WIDTH_ORDER.filter((w) => cells.some((c) => c.width === w)),
			colors: Object.keys(COLOR_HEX).filter((n) => cells.some((c) => c.colors.includes(n))),
			brand: [...new Set(cells.map((c) => c.brand).filter(Boolean))]
		};
		for (const [group, list] of Object.entries(values)) {
			const fs = $(`[data-rcc-group="${group}"]`, sheet);
			if (!fs) continue;
			fs.hidden = list.length < (group === 'brand' ? 1 : 2);
			$('.rcc-opts', fs).innerHTML = list
				.map((v) => `<button type="button" class="rcc-opt" aria-pressed="false" data-g="${group}" data-v="${esc(v)}">${group === 'colors' ? `<span class="rcc-swatch" style="background:${COLOR_HEX[v]}"></span>` : ''}${esc(v)}</button>`)
				.join('');
		}
		// "Designer" can be preset from the URL, e.g. ?designer=Farrisilk
		const pre = new URLSearchParams(location.search).get('designer');
		if (pre && values.brand.includes(pre)) state.brand.add(pre);

		function apply() {
			let shown = cells.filter(
				(c) =>
					(state.type === 'all' || c.type === state.type) &&
					(!state.width.size || state.width.has(c.width)) &&
					(!state.colors.size || c.colors.some((x) => state.colors.has(x))) &&
					(!state.brand.size || state.brand.has(c.brand))
			);
			const by = {
				featured: (a, b) => Number(a.soon) - Number(b.soon) || a.index - b.index,
				new: (a, b) => b.created - a.created,
				low: (a, b) => a.price - b.price,
				high: (a, b) => b.price - a.price
			}[state.sort];
			shown = shown.sort(by);
			const set = new Set(shown);
			cells.forEach((c) => (c.el.hidden = !set.has(c)));
			shown.forEach((c) => grid.appendChild(c.el));
			const n = shown.length;
			$('[data-rcc-countline]', box).textContent = `${n} ${n === 1 ? 'piece' : 'pieces'}`;
			$('[data-rcc-none]', box).hidden = n > 0;
			const active = state.width.size + state.colors.size + state.brand.size + (state.sort !== 'featured' ? 1 : 0);
			const badge = $('[data-rcc-badge]', box);
			badge.hidden = !active;
			badge.textContent = active;
			$('[data-rcc-showbtn]', box).textContent = `Show ${n}`;
			$$('[data-rcc-type]', box).forEach((b) => {
				const on = b.dataset.rccType === state.type;
				b.classList.toggle('is-on', on);
				b.setAttribute('aria-selected', on);
			});
			$$('[data-rcc-sort] .rcc-opt', box).forEach((b) => b.classList.toggle('is-on', b.dataset.v === state.sort));
			$$('.rcc-opt[data-g]', box).forEach((b) => {
				const on = state[b.dataset.g].has(b.dataset.v);
				b.classList.toggle('is-on', on);
				b.setAttribute('aria-pressed', on);
			});
		}
		box.addEventListener('click', (e) => {
			const t = e.target.closest('[data-rcc-type]');
			if (t) {
				state.type = t.dataset.rccType;
				return apply();
			}
			const s = e.target.closest('[data-rcc-sort] .rcc-opt');
			if (s) {
				state.sort = s.dataset.v;
				return apply();
			}
			const o = e.target.closest('.rcc-opt[data-g]');
			if (o) {
				const g = state[o.dataset.g];
				g.has(o.dataset.v) ? g.delete(o.dataset.v) : g.add(o.dataset.v);
				return apply();
			}
			if (e.target.closest('[data-rcc-clear]')) {
				state.width.clear();
				state.colors.clear();
				state.brand.clear();
				state.sort = 'featured';
				state.type = 'all';
				apply();
			}
		});
		apply();
	}

	/* ---------- product page ---------- */
	function initProduct(scope = document) {
		const box = $('[data-rcc-product]', scope);
		if (!box || box.dataset.ready) return;
		box.dataset.ready = '1';
		// Gallery: swipe rail, dots and thumbnails stay in sync.
		const rail = $('[data-rcc-gallery]', box);
		const marks = $$('[data-to]', box);
		const mark = (i) => marks.forEach((m) => m.classList.toggle('is-on', Number(m.dataset.to) === i));
		rail?.addEventListener('scroll', () => mark(Math.round(rail.scrollLeft / rail.clientWidth)), { passive: true });
		marks.forEach((m) =>
			m.addEventListener('click', () => {
				const i = Number(m.dataset.to);
				rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' });
				mark(i);
			})
		);
		// Quantity stepper and the running total on the button.
		const form = $('[data-rcc-buy]', box);
		const qty = $('[data-rcc-qtyinput]', box);
		const total = $('[data-rcc-total]', box);
		const variant = $('[data-rcc-variant]', box);
		const unit = () => {
			const opt = variant?.selectedOptions[0];
			const text = opt ? opt.dataset.price : total?.dataset.unit || total?.textContent;
			return Math.round(parseFloat(String(text).replace(/[^0-9.]/g, '')) * 100);
		};
		if (total) total.dataset.unit = total.textContent;
		const update = () => {
			const q = Math.max(1, Number(qty?.value) || 1);
			if (qty) qty.value = q;
			if (total) total.textContent = money(unit() * q);
			const priceEl = $('[data-rcc-price]', box);
			if (variant && priceEl) priceEl.textContent = variant.selectedOptions[0].dataset.price;
		};
		form?.addEventListener('click', (e) => {
			const s = e.target.closest('[data-rcc-step]');
			if (!s) return;
			qty.value = Math.max(1, (Number(qty.value) || 1) + Number(s.dataset.rccStep));
			update();
		});
		qty?.addEventListener('change', update);
		variant?.addEventListener('change', () => {
			$$('[data-rcc-add]', box).forEach((b) => (b.dataset.rccAdd = variant.value));
			update();
		});
		// Phone: sticky bar once the main buy area has scrolled away.
		const sticky = $('[data-rcc-sticky]', box);
		if (sticky && form && 'IntersectionObserver' in window) {
			const io = new IntersectionObserver(([e]) => {
				const on = !e.isIntersecting && e.boundingClientRect.top < 0;
				sticky.classList.toggle('is-on', on);
				sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
				$('button', sticky).tabIndex = on ? 0 : -1;
			});
			io.observe(form);
		}
	}

	/* ---------- tabs (product rows) ---------- */
	document.addEventListener('click', (e) => {
		const tab = e.target.closest('[data-rcc-tab]');
		if (!tab) return;
		const box = tab.closest('[data-rcc-tabs]');
		$$('[data-rcc-tab]', box).forEach((t) => {
			const on = t === tab;
			t.classList.toggle('is-on', on);
			t.setAttribute('aria-selected', on);
		});
		$$('[data-rcc-pane]', box).forEach((p) => (p.hidden = p.dataset.rccPane !== tab.dataset.rccTab));
	});

	/* ---------- rail arrows ---------- */
	document.addEventListener('click', (e) => {
		const b = e.target.closest('[data-rcc-rail]');
		if (!b) return;
		// Scroll the row that is showing (a tabbed section has one row per tab).
		const rail = b.closest('section')?.querySelector('.rcc-rail:not([hidden])') || document.getElementById(b.dataset.rccRail);
		rail?.scrollBy({ left: Number(b.dataset.dir) * rail.clientWidth * 0.8, behavior: 'smooth' });
	});

	function init(scope) {
		initHeader();
		initAnnounce();
		initSearch();
		initHero(scope);
		initCountdown(scope);
		initCollection(scope);
		initProduct(scope);
		initReveal(scope);
	}
	window.RCC = { refresh, add, show, hide, initReveal };
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
	else init();
	refresh();
	document.addEventListener('shopify:section:load', (e) => {
		initAnnounce();
		initSearch();
		initHero(e.target);
		initCountdown(e.target);
		initCollection(e.target);
		initProduct(e.target);
		initReveal(e.target);
		if (e.target.querySelector('[data-rcc-header]')) initHeader();
	});
})();
